module.exports = __webpack_public_path__ + "img/0043661.png";